import { z } from "zod";
import { createZodDto } from "nestjs-zod/dto";
export const AVAILABLE_METRICS = [
  "totalUser",
  "paymentComplete",
  "resumeCreated",
  "downloadComplete",
] as const;

export type MetricKey = (typeof AVAILABLE_METRICS)[number];

export const metricQuerySchema = z.object({
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
  metric: z.array(z.string()),
  // .transform((val) => {
  //     if(!val) return []
  //     return val.split(",").map(item => item.trim())
  // })
  // .pipe(
  //   z.array(
  //     z.enum(AVAILABLE_METRICS, {
  //       errorMap: () => ({
  //         message: `Métrique invalide. Autorisées : ${AVAILABLE_METRICS.join(', ')}`,
  //       }),
  //     })
  //   )
  // ),
});

export class MetricsQueryDto extends createZodDto(metricQuerySchema) {}
